import { createNewProduct, getAllProducts, updateProduct } from '../api/products';

const ADD_ALL_PRODUCTS = 'ADD_ALL_PRODUCTS';
const ADD_NEW_PRODUCT = 'ADD_NEW_PRODUCT';
const LOADED_ALL_PRODUCTS = 'LOADED_ALL_PRODUCTS';
const UPDATE_EXISTING_PRODUCT = 'UPDATE_EXISTING_PRODUCT';

const INITIAL_STATE = {
  isAllProductsLoaded: false,
  products: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_ALL_PRODUCTS:
      return {
        ...state,
        products: [...action.payload].sort((a, b) => a.name.localeCompare(b.name)),
      };
    case ADD_NEW_PRODUCT:
      return {
        products: [...state.products, action.payload].sort((a, b) => a.name.localeCompare(b.name)),
      };
    case UPDATE_EXISTING_PRODUCT:
      return {
        ...state,
        products: [
          ...state.products.filter(product => product.id !== action.payload.id),
          action.payload,
        ].sort((a, b) => a.name.localeCompare(b.name)),
      };
    case LOADED_ALL_PRODUCTS:
      return {
        ...state,
        isAllProductsLoaded: true,
      };
    default:
      return state;
  }
}

export function fetchAllProducts() {
  return async (dispatch) => {
    try {
      const products = await getAllProducts();

      dispatch({
        type: ADD_ALL_PRODUCTS,
        payload: products,
      });

      return dispatch({ type: LOADED_ALL_PRODUCTS });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function addNewProduct(product) {
  return async (dispatch) => {
    try {
      const p = await createNewProduct(product);

      return dispatch({
        type: ADD_NEW_PRODUCT,
        payload: p,
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function editExistingProduct(id, product) {
  return async (dispatch) => {
    try {
      const p = await updateProduct(id, product);

      return dispatch({
        type: UPDATE_EXISTING_PRODUCT,
        payload: p,
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
